module.exports = __webpack_public_path__ + "02e4837510e6687dc950ee6d0bbb7a31.svg";